// Vocabulários e validações dos templates HSM — espelham o contrato do UniService
// (mesmo do UniTicket). Payload de criação é "flat"; o UniService monta os
// components da Meta.

export const CATEGORIES = [
  { label: 'Utilidade', value: 'UTILITY', description: 'Confirmações, atualizações de pedido, alertas.' },
  { label: 'Marketing', value: 'MARKETING', description: 'Promoções, novidades e ofertas.' },
  { label: 'Autenticação', value: 'AUTHENTICATION', description: 'Códigos de verificação (OTP).' },
];

export const LANGUAGES = [
  { label: 'Português (BR)', value: 'pt_BR' },
  { label: 'Inglês (US)', value: 'en_US' },
  { label: 'Inglês (UK)', value: 'en_GB' },
  { label: 'Espanhol', value: 'es' },
  { label: 'Espanhol (MX)', value: 'es_MX' },
];

export const HEADER_TYPES = [
  { label: 'Nenhum', value: 'NONE' },
  { label: 'Texto', value: 'TEXT' },
  { label: 'Imagem', value: 'IMAGE' },
  { label: 'Vídeo', value: 'VIDEO' },
  { label: 'Documento', value: 'DOCUMENT' },
];

export const BUTTON_TYPES = [
  { label: 'Resposta rápida', value: 'QUICK_REPLY' },
  { label: 'Link (URL)', value: 'URL' },
  { label: 'Telefone', value: 'PHONE_NUMBER' },
  { label: 'Copiar código', value: 'COPY_CODE' },
];

export const STATUS = {
  APPROVED: { label: 'Aprovado', color: 'green' },
  PENDING: { label: 'Pendente', color: 'orange' },
  IN_APPEAL: { label: 'Em recurso', color: 'orange' },
  REJECTED: { label: 'Rejeitado', color: 'red' },
  PAUSED: { label: 'Pausado', color: 'orange' },
  DISABLED: { label: 'Desativado', color: 'red' },
};

export const CATEGORY_LABEL = CATEGORIES.reduce((acc, c) => ({ ...acc, [c.value]: c.label }), {});

export const FILTERS = [
  { key: 'ALL', label: 'Todos' },
  { key: 'APPROVED', label: 'Aprovados' },
  { key: 'PENDING', label: 'Pendentes' },
  { key: 'REJECTED', label: 'Rejeitados' },
  { key: 'HIDDEN', label: 'Ocultos' },
];

// Números de variáveis {{n}} presentes num texto, únicos e ordenados.
export const numberedVars = (text = '') => {
  const nums = (String(text).match(/{{\s*(\d+)\s*}}/g) || []).map((m) => Number(m.replace(/\D/g, '')));
  return [...new Set(nums)].sort((a, b) => a - b);
};

export const EDITABLE_STATUS = ['APPROVED', 'REJECTED', 'PAUSED'];

// Template essencial do MenuCheff (opt-in de pedido). Criado automaticamente e
// protegido contra exclusão — precisa existir sempre para as notificações de
// pedido funcionarem fora da janela de 24h.
export const PROTECTED_TEMPLATE_NAME = 'menucheff_pedido';

// Valida o formulário do template e devolve a lista de problemas (vazia = ok).
export const validateTemplate = (form, isEdit) => {
  const problems = [];
  if (!isEdit) {
    if (!/^[a-z][a-z0-9_]*$/.test(form.name)) {
      problems.push('O nome deve começar com letra e conter apenas letras minúsculas, números e "_".');
    }
  }
  if (!form.bodyText?.trim()) problems.push('O corpo da mensagem é obrigatório.');
  if ((form.bodyText || '').length > 1024) problems.push('O corpo não pode passar de 1024 caracteres.');

  const bodyVars = numberedVars(form.bodyText);
  bodyVars.forEach((n, i) => {
    if (n !== i + 1) problems.push('As variáveis do corpo devem ser sequenciais a partir de {{1}}.');
    if (!form.examples?.[n]?.trim()) problems.push(`Informe um exemplo para {{${n}}}.`);
  });

  if (form.headerType === 'TEXT') {
    if ((form.headerContent || '').length > 60) problems.push('O cabeçalho de texto tem no máximo 60 caracteres.');
    if (/{{/.test(form.headerContent || '')) problems.push('O cabeçalho de texto não aceita variáveis.');
  }
  if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(form.headerType) && !form.headerContent?.trim()) {
    problems.push('Informe uma URL de exemplo para a mídia do cabeçalho.');
  }
  if ((form.footerText || '').length > 60) problems.push('O rodapé tem no máximo 60 caracteres.');

  (form.buttons || []).forEach((b, i) => {
    if (!b.text?.trim()) problems.push(`O botão ${i + 1} precisa de um texto.`);
    if ((b.text || '').length > 25) problems.push(`O texto do botão ${i + 1} tem no máximo 25 caracteres.`);
    if (b.type === 'URL' && !/^https?:\/\//.test(b.url || '')) problems.push(`O botão ${i + 1} precisa de uma URL válida.`);
    if (b.type === 'PHONE_NUMBER' && !/^\+\d{6,}$/.test(b.phone_number || '')) {
      problems.push(`O botão ${i + 1} precisa de um telefone no formato +55...`);
    }
  });
  const buttons = form.buttons || [];
  if (buttons.length > 10) problems.push('Máximo de 10 botões.');
  if (buttons.filter((b) => b.type === 'COPY_CODE').length && form.category !== 'AUTHENTICATION') {
    problems.push('Botão "Copiar código" só é permitido em templates de Autenticação.');
  }
  return problems;
};
